// Dependencies
import { FC, SyntheticEvent, useState } from "react";

// Components
import { Tab } from "@mui/material";
import CategoryList from "../CategoryList";

// Types
import { TCategoryData } from "~/types";

// Styles
import { StyledTabs } from "./Categories.styled";

interface CategoriesProps {
  data: TCategoryData[];
  onSelect: Function;
}

const Categories: FC<CategoriesProps> = ({ data, onSelect }) => {
  const [tabValue, setTabValue] = useState<string>(data[0]?.type);

  const typeNum = data.length;

  // methods
  const handleSetTab = (event: SyntheticEvent, value: string) => {
    setTabValue(value);
  };
  return (
    <>
      <StyledTabs value={tabValue} onChange={handleSetTab}>
        {data?.map((tab) => (
          <Tab
            label={tab.description}
            value={tab.type}
            key={tab.type}
            sx={{ width: `${(1 / typeNum) * 100}%`, minWidth: "fit-content" }}
          />
        ))}
      </StyledTabs>
      {Array.from({ length: typeNum }).map((item, index) => (
        <CategoryList
          data={data[index].list}
          value={tabValue}
          index={data[index].type}
          key={index}
          onSelect={onSelect}
        />
      ))}
    </>
  );
};

export default Categories;
